import { toast } from "react-toastify";
import {
  addGuestsApi,
  createAudienceApi,
  deleteAudienceApi,
  getAudiencesApi,
  updateAudienceApi,
} from "../../services/AudienceService";
import { GET_AUDIENCES } from "./AudienceTypes";
import { loadingModel } from "./CommonActions";

export function deleteAudienceAction(id, history) {
  return (dispatch, getState) => {
    deleteAudienceApi(id)
      .then((response) => {
        //   dispatch(confirmedDeletePostAction(postId));
        // history.push("/audience");
      })
      .catch((error) => {
        const message =
          error.response?.data?.message ||
          error.message ||
          "Something went wrong!";
        toast.error(message);
        return error;
      });
  };
}

// export function confirmedDeletePostAction(postId) {
//   return {
//     type: CONFIRMED_DELETE_POST_ACTION,
//     payload: postId,
//   };
// }

export function createAudience(data, history) {
  return async (dispatch, getState) => {
    return await createAudienceApi(data)
      .then((response) => {
        // console.log("sbvuisebvsevsev", response);
        // const singlePost = {
        //     ...postData,
        //     id: response.data.name,
        // };
        //   dispatch(getAudiences());
        // dispatch(confirmedCreatePostAction(singlePost));
        // history.push("/audience");
        return response;
      })
      .catch((error) => {
        // return error;
        console.log("anvuoinsevsev", error);
      });
  };
}

export function getAudiences({ page = 1, search = "", limit = 10 }) {
  return (dispatch, getState) => {
    dispatch(loadingModel(true, GET_AUDIENCES));
    getAudiencesApi({ page, search, limit }).then((response) => {
      // let posts = formatPosts(response.data);
      dispatch(loadingModel(false, GET_AUDIENCES));
      dispatch(confirmedGetAudiencesAction(response?.data?.data));
    });
  };
}

export function confirmedGetAudiencesAction(data) {
  return {
    type: GET_AUDIENCES,
    payload: data,
  };
}

// export function loadingModel(loading) {
//   return {
//     type: "LOADING",
//     loading,
//   };
// }

export function updateAudienceAction(data, history) {
  return async (dispatch, getState) => {
    return await updateAudienceApi(data, data._id)
      .then((response) => {
        // console.log("sbvuisebvsevsev", response);
        // const singlePost = {
        //     ...postData,
        //     id: response.data.name,
        // };
        //   dispatch(getAudiences());
        // dispatch(confirmedCreatePostAction(singlePost));
        // history.push("/audience");
        return response;
      })
      .catch((error) => {
        // return error;
        console.log("anvuoinsevsev", error);
      });
  };
}

export function addGuestsAction(data, history) {
  return (dispatch, getState) => {
    addGuestsApi(data).then((reponse) => {
      //   dispatch(confirmedUpdatePostAction(post));
      history.push("/audience");
    });
  };
}
